import sketch from './app/sketch';

// Initialize sketch
new p5(sketch);